export const ReplyCommentInitialVal = {
  replyText: "",
};
